module.exports = __webpack_public_path__ + "media/images/search-icon-2f1d364d8be338eab709070f0e91fc21.png";